import styled from 'styled-components';
import { BREAK_POINTS } from '@origin-digital/style-guide';

export const ContinueContainer = styled.div`
  & > div {
    display: block;
  }

  @media screen and (max-width: ${BREAK_POINTS.Min.SM}) {
    button {
      display: block;
      width: 100%;
    }
  }
`;

export const FixedErrorContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1001;
  width: 100%;
`;

export const ErrorContainer = styled.div`
  height: 64px;
  border: solid 1px #fbd6d6;
  background-color: #fdeaea;
  color: #710000;
  font-size: 14px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 16px;

  svg {
    margin-right: 10px;
  }
  & > div {
    padding: 0 16px;
  }

  @media screen and (min-width: ${BREAK_POINTS.Min.SM}) {
    align-items: center;
    & > div {
      display: flex;
      width: 540px;
    }
  }
  @media screen and (min-width: ${BREAK_POINTS.Min.MD}) {
    & > div {
      width: 724px;
    }
  }
`;

export const ActionsContainer = styled.div`
  & > *:not(:last-child) {
    margin-bottom: 24px;
  }

  @media screen and (max-width: ${BREAK_POINTS.Max.SM}) {
    text-align: center;
    a {
      display: inline-block;
    }
  }
`;
